import React, { useState, useEffect } from "react";
import { HashLink } from "react-router-hash-link";
import { useLocation } from "react-router-dom";
import LogoTradutec from "../assets/img/tradutec_logo_2026_color.png";


function Header() {

    const location = useLocation();

    const [menuOpen, setMenuOpen] = useState(false);
    const [subMenuOpen, setSubMenuOpen] = useState(false);
    const [activeSection, setActiveSection] = useState("#inicio");


    // Cerrar menú cuando cambia la ruta
    useEffect(() => {

        setMenuOpen(false);
        setSubMenuOpen(false);

    }, [location]);



    // Detectar sección visible durante el scroll
    useEffect(() => {

        const sections = document.querySelectorAll("section[id]");


        const observer = new IntersectionObserver(
            (entries) => {

                entries.forEach((entry) => {

                    if (entry.isIntersecting) {

                        setActiveSection(
                            `#${entry.target.id}`
                        );

                    }

                });

            },
            {
                threshold: 0.5
            }
        );



        sections.forEach((section) => {

            observer.observe(section);

        });



        return () => {

            sections.forEach((section) => {

                observer.unobserve(section);

            });

        };


    }, []);





    const closeMenu = () => {

        setMenuOpen(false);
        setSubMenuOpen(false);

    };




    const isActive = (hash) => {


        // Si está dentro de una página interna de servicios
        if (location.pathname.startsWith("/servicios")) {

            return hash === "#servicios";

        }


        return activeSection === hash;


    };




    return (

        <header className="site-header">

            <div className="wrap">



                {/* LOGO */}

                <a
                    className="logo"
                    href="/"
                    onClick={closeMenu}
                >

                    <img
                        src={LogoTradutec}
                        alt="Tradutec Perú"
                    />

                </a>





                {/* MENU */}

                <nav
                    className={`main-nav ${menuOpen ? "open" : ""}`}
                >




                    <HashLink
                        smooth
                        to="/#inicio"
                        onClick={closeMenu}
                        className={
                            isActive("#inicio")
                                ? "active"
                                : ""
                        }
                    >
                        Inicio
                    </HashLink>





                    <HashLink
                        smooth
                        to="/#empresa"
                        onClick={closeMenu}
                        className={
                            isActive("#empresa")
                                ? "active"
                                : ""
                        }
                    >
                        Nuestra empresa
                    </HashLink>






                    {/* SERVICIOS */}

                    <div
                        className={
                            `has-sub ${subMenuOpen
                                ? "sub-open"
                                : ""
                            }`
                        }
                    >



                        <HashLink
                            smooth
                            to="/#servicios"
                            className={
                                isActive("#servicios")
                                    ? "active"
                                    : ""
                            }

                            onClick={(e) => {


                                if (window.innerWidth <= 991) {


                                    e.preventDefault();

                                    setSubMenuOpen(
                                        !subMenuOpen
                                    );


                                } else {

                                    closeMenu();

                                }


                            }}

                        >

                            Servicios
                            <i className="fas fa-caret-down"></i>

                        </HashLink>





                        <div className="sub">


                            <a
                                href="/servicios/traduccion-certificada/"
                                onClick={closeMenu}
                            >
                                Traducción Certificada (CTP)
                            </a>



                            <a
                                href="/servicios/traduccion-simple/"
                                onClick={closeMenu}
                            >
                                Traducción no certificada o simple
                            </a>



                            <a
                                href="/servicios/traduccion-especializada/"
                                onClick={closeMenu}
                            >
                                Traducción especializada
                            </a>



                            <a
                                href="/servicios/traduccion-urgente/"
                                onClick={closeMenu}
                            >
                                Traducción urgente
                            </a>



                            <a
                                href="/servicios/interpretacion-simultanea/"
                                onClick={closeMenu}
                            >
                                Interpretación simultánea
                            </a>



                            <a
                                href="/servicios/interpretacion-consecutiva/"
                                onClick={closeMenu}
                            >
                                Interpretación consecutiva
                            </a>



                            <a
                                href="/servicios/interpretacion-de-enlace/"
                                onClick={closeMenu}
                            >
                                Interpretación de enlace
                            </a>



                            <a
                                href="/servicios/otros-servicios/"
                                onClick={closeMenu}
                            >
                                Otros servicios
                            </a>


                        </div>


                    </div>







                    <HashLink
                        smooth
                        to="/#proyectos"
                        onClick={closeMenu}
                        className={
                            isActive("#proyectos")
                                ? "active"
                                : ""
                        }
                    >

                        Nuestros proyectos

                    </HashLink>






                    <HashLink
                        smooth
                        to="/#contacto"
                        onClick={closeMenu}
                        className={
                            isActive("#contacto")
                                ? "active"
                                : ""
                        }
                    >

                        Contáctenos

                    </HashLink>




                </nav>







                {/* BOTON COTIZACION */}

                <HashLink
                    smooth
                    to="/#contacto"
                    className="btn btn-gold header-cta"
                    onClick={closeMenu}
                >

                    Solicitar cotización
                    <i className="fas fa-paper-plane"></i>

                </HashLink>






                {/* MENU MOBILE */}

                <button
                    className="nav-toggle"
                    aria-label="menu"
                    onClick={() =>
                        setMenuOpen(!menuOpen)
                    }
                >

                    <i
                        className={
                            `fas ${menuOpen
                                ? "fa-times"
                                : "fa-bars"
                            }`
                        }
                    ></i>


                </button>



            </div>


        </header>

    );

}


export default Header;